import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

class GptBackService {
    constructor(router, location) {
        this.router = router;
        this.location = location;
        this.history = [];
        this.destroy$ = new Subject();
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.history.push(event.urlAfterRedirects);
            }
        });
    }
    back(url, fragment, forceUrl) {
        if (forceUrl) {
            this.router.navigate([url || '/'], { fragment });
            return;
        }
        this.history.pop();
        if (this.history.length > 0) {
            this.location.back();
        }
        else {
            this.router.navigate([url || '/'], { fragment });
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptBackService, deps: [{ token: i1.Router }, { token: i2.Location }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptBackService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptBackService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i2.Location }]; } });

class GptRouterBackComponent {
    constructor(nav) {
        this.nav = nav;
        this.forceUrl = false;
        this.disabledNav = false;
        this.backClicked = new EventEmitter();
    }
    click() {
        if (!this.disabledNav) {
            this.nav.back(this.url, this.fragment, this.forceUrl);
        }
        this.backClicked.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptRouterBackComponent, deps: [{ token: GptBackService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.3", type: GptRouterBackComponent, selector: "gpt-router-back", inputs: { class: "class", fragment: "fragment", url: "url", forceUrl: "forceUrl", disabledNav: "disabledNav" }, outputs: { backClicked: "backClicked" }, ngImport: i0, template: "<a (click)=\"click()\" [class]=\"class\" role=\"button\">\n  <i class=\"d-none d-md-block gpicon-back-fat\"></i>\n  <i class=\"d-block d-md-none gpicon-left-chevron gpicon-md\"></i>\n</a>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptRouterBackComponent, decorators: [{
            type: Component,
            args: [{ selector: 'gpt-router-back', changeDetection: ChangeDetectionStrategy.OnPush, template: "<a (click)=\"click()\" [class]=\"class\" role=\"button\">\n  <i class=\"d-none d-md-block gpicon-back-fat\"></i>\n  <i class=\"d-block d-md-none gpicon-left-chevron gpicon-md\"></i>\n</a>\n" }]
        }], ctorParameters: function () { return [{ type: GptBackService }]; }, propDecorators: { class: [{
                type: Input
            }], fragment: [{
                type: Input
            }], url: [{
                type: Input
            }], forceUrl: [{
                type: Input
            }], disabledNav: [{
                type: Input
            }], backClicked: [{
                type: Output
            }] } });

class GptRouterBackModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptRouterBackModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.3", ngImport: i0, type: GptRouterBackModule, declarations: [GptRouterBackComponent], imports: [CommonModule], exports: [GptRouterBackComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptRouterBackModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.3", ngImport: i0, type: GptRouterBackModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [GptRouterBackComponent],
                    imports: [CommonModule],
                    exports: [GptRouterBackComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { GptBackService, GptRouterBackComponent, GptRouterBackModule };
